import { render, staticRenderFns } from "./DialogWarning.vue?vue&type=template&id=0061fdc6&scoped=true"
import script from "./DialogWarning.vue?vue&type=script&lang=js"
export * from "./DialogWarning.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0061fdc6",
  null
  
)

export default component.exports